import React from 'react';
import PropTypes from 'prop-types';
import Footer from '../Footer';
// import SafeHTML from '../SafeHTML';


export default class GenericNavList extends React.Component {

  constructor(props) {
    super(props);
    this.state = { visibleSubMenuId: "" };
  }
  static propTypes = {
    items: PropTypes.array,
    prefix: PropTypes.string,
    showDesc: PropTypes.bool,
  }

  static defaultProps = {
    prefix: 'menu',
    showDesc: true
  }
  toggleSubMenu = (event, subMenuId) => {
    event.preventDefault();
    this.setState({ visibleSubMenuId: subMenuId });
  }
  getInnerMenuWithDesc(item) {
    return <>
      <div className="mega-menu-left">
        <h2 className="menu-title">{item.label}</h2>
        <p>{item.desc} {this.props.showDesc}</p>
      </div>
      <div className="mega-menu-right">
        <GenericNavList items={item.children} showDesc={this.props.showDesc}></GenericNavList>
        <button className="btn btn-circle nav-back-link" onClick={(e) => { this.toggleSubMenu(e, "") }}>
          <i className="icon icon-prev"></i>
        </button>
      </div>
    </>;
  }
  getInnerMenuWithOutDesc(item) {
    return <GenericNavList items={item.children} showDesc={this.props.showDesc}></GenericNavList>;
  }
  getChildMenu(item) {
    if (item.children && item.children.length > 0) {
      return (<div className={"sub-nav mega-menu" + (this.state.visibleSubMenuId == item.label.replace(/\s+/g, '') ? " open" : "")}>
        {this.props.showDesc ? this.getInnerMenuWithDesc(item) : this.getInnerMenuWithOutDesc(item)}
      </div>);
    }
    return null;
  }
  
  render() {
    return (
      <ul className={`${this.props.prefix}`}>
        {
          this.props.items.map((item, i) => {
            let current = RegExp(item.href, 'g').test(window.location.href);
            let footer = this.props.footer;
            return (
              <li
                data-active={item.active}
                key={i}
                className={`${current ? 'active' : ''}` + `${item.children.length > 0 ? ' has-menu' : footer}`}>
                <a
                  href={item.href} target={item.openInNewWindow ? '_blank' : ''}>
                  {item.label}
                  {item.children.length > 0 &&
                    <i className="nav-icon icon-arrow-right" onClick={(e) => { this.toggleSubMenu(e, item.label.replace(/\s+/g, '')) }}></i>
                  }
                </a>
                {this.getChildMenu(item)}

              </li>
            );
          })
        }
        {this.props.children}
      </ul>
    )
  }

}